export default __webpack_public_path__ + "media/images/icons/loading-67f11ff18ca227dd4eca45c63e090376.gif";